import {
  Car,
  Container,
  Truck,
  PackageOpen,
  Plane,
  FileCheck,
  ShieldCheck,
  BadgeDollarSign,
  Timer,
  Lock,
  Radar,
  Users,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Cars", href: "/cars" },
  { label: "Routes", href: "/routes" },
  { label: "Why Us", href: "/why-us" },
  { label: "Track", href: "/#track" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

export const SERVICES = [
  {
    icon: Car,
    title: "Vehicle Shipping",
    desc: "Safe transportation of sedans, SUVs, trucks, luxury vehicles, motorcycles, and heavy equipment.",
  },
  {
    icon: Container,
    title: "Container Shipping",
    desc: "20ft and 40ft container shipping from the USA to Ghana with full and shared load options.",
  },
  {
    icon: Truck,
    title: "Towing Services",
    desc: "Professional towing and transport throughout the United States before shipment.",
  },
  {
    icon: PackageOpen,
    title: "Cargo Shipping",
    desc: "Personal effects, commercial goods, household items, and business equipment.",
  },
  {
    icon: Plane,
    title: "Air Freight",
    desc: "Fast international air shipping for urgent and time-sensitive deliveries.",
  },
  {
    icon: FileCheck,
    title: "Customs Assistance",
    desc: "We help customers clear cargo smoothly and quickly at Tema Port, Ghana.",
  },
];

export const ROUTES = [
  { from: "New York / New Jersey", to: "Tema", days: "18–25 days" },
  { from: "Los Angeles", to: "Tema", days: "28–35 days" },
  { from: "Seattle", to: "Tema", days: "30–38 days" },
  { from: "Houston", to: "Tema", days: "22–30 days" },
  { from: "Savannah", to: "Tema", days: "16–22 days" },
];

export const WHY_US = [
  { icon: ShieldCheck, title: "Reliable Shipping", desc: "Trusted schedules and dependable delivery, shipment after shipment." },
  { icon: BadgeDollarSign, title: "Affordable Pricing", desc: "Transparent, competitive rates with no hidden fees." },
  { icon: Timer, title: "Fast Delivery", desc: "Optimized routes to get your vehicle and cargo to Ghana quickly." },
  { icon: Lock, title: "Secure Vehicle Handling", desc: "Careful loading, lashing, and handling of every vehicle." },
  { icon: Radar, title: "Cargo Tracking", desc: "Track your shipment online from pickup to arrival at Tema Port." },
  { icon: Users, title: "Experienced Team", desc: "A seasoned logistics team managing your shipment end-to-end." },
];

export const STEPS = [
  { n: "01", title: "Request a Quote", desc: "Tell us what you're shipping and where from. Get a fast, free quote." },
  { n: "02", title: "Drop Off Vehicle or Cargo", desc: "Deliver to our US facility, or we'll tow it for you." },
  { n: "03", title: "We Handle Shipping", desc: "Loading, documentation, customs, and ocean or air freight." },
  { n: "04", title: "Receive in Ghana", desc: "Clear and collect your shipment at Tema Port with our help." },
];

export const TESTIMONIALS = [
  { name: "Kwame A.", location: "Accra, Ghana", text: "My vehicle arrived safely in Tema exactly as promised. Professional from start to finish." },
  { name: "Sarah M.", location: "Houston, USA", text: "Excellent communication and affordable pricing. I always knew where my shipment was." },
  { name: "Daniel O.", location: "Kumasi, Ghana", text: "Highly recommended for shipping cars to Ghana. Smooth customs clearance at Tema Port." },
];

export const FAQS = [
  { q: "How long does shipping take?", a: "Ocean freight typically takes between 16 and 38 days depending on the US departure port. Air freight is much faster for urgent deliveries. We provide an estimated delivery window with every quote." },
  { q: "How much does it cost?", a: "Cost depends on the vehicle or cargo size, the departure port, and shipping method (container vs. RoRo vs. air). Request a free quote and we'll give you a transparent, all-in price." },
  { q: "Can I ship personal items inside my vehicle?", a: "In many cases yes, within allowed limits. We'll advise you on what can be shipped inside the vehicle to stay compliant with customs regulations." },
  { q: "Do you offer container shipping?", a: "Yes. We offer both 20ft and 40ft containers, as well as shared container space for smaller shipments." },
  { q: "Can I track my shipment?", a: "Absolutely. Every shipment gets a tracking ID you can enter on our website to see its current status and location." },
  { q: "Do you provide customs assistance?", a: "Yes. We help you clear your vehicle or cargo at Tema Port quickly and correctly, reducing delays and demurrage." },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1670121180583-39ab653a071c", alt: "Cargo ship at port", tall: true },
  { url: "https://images.unsplash.com/photo-1698998882426-39a6609ab10a", alt: "Tow truck with vehicle on flatbed" },
  { url: "https://images.unsplash.com/photo-1568723331958-ce8c291349e7", alt: "Luxury SUV" },
  { url: "https://images.unsplash.com/photo-1700777685830-f501e67260e6", alt: "Crane loading shipping container", tall: true },
  { url: "https://images.unsplash.com/photo-1613690399151-65ea69478674", alt: "Container ship on the ocean" },
  { url: "https://images.unsplash.com/photo-1706499856012-14f062c72b49", alt: "Stacked shipping containers" },
  { url: "https://images.unsplash.com/photo-1542296332-2e4473faf563", alt: "Air cargo aircraft loading", tall: true },
  { url: "https://images.unsplash.com/photo-1567604804217-9be3addbd802", alt: "Luxury Mercedes vehicle" },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1605745341112-85968b19335b";
